module.exports = __webpack_public_path__ + "img/policeBadge.0c57706.png";